/* ==========================================================================
   VD-HOME.JS — Home premium VELDROP (solo se carga en layout/home.liquid)
   Sin dependencias. Todo con guards: si un elemento no existe, no rompe.
   ========================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     1. Barra superior de confianza: mensajes rotativos
        - Autorrota cada N segundos (data-interval del section)
        - Pausa on-hover, flechas manuales, respeta prefers-reduced-motion
     ---------------------------------------------------------------------- */
  function initTopbar(root) {
    var bar = (root || document).querySelector('.vd-topbar');
    if (!bar || bar.dataset.vdInit) return;
    bar.dataset.vdInit = '1';

    var msgs = bar.querySelectorAll('.vd-topbar__msg');
    if (!msgs.length) return;
    var current = 0, timer = null;
    var interval = (parseInt(bar.dataset.interval, 10) || 4) * 1000;

    function show(i) {
      current = (i + msgs.length) % msgs.length;
      for (var j = 0; j < msgs.length; j++) msgs[j].classList.toggle('is-active', j === current);
    }
    function next() { show(current + 1); }
    function play() {
      if (reducedMotion || msgs.length < 2) return;
      stop();
      timer = setInterval(next, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    show(0);
    if (msgs.length < 2) { bar.classList.add('vd-topbar--single'); return; }

    var prevBtn = bar.querySelector('.vd-topbar__nav--prev');
    var nextBtn = bar.querySelector('.vd-topbar__nav--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); play(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); play(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', play);
    play();
  }

  /* ----------------------------------------------------------------------
     2. Header: alto real en --vd-header-h, estado scrolled (para el modo
        transparente sobre el hero) y modo overlay solo si hay hero debajo.
     ---------------------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('.vd-header');
    if (!header || header.dataset.vdInit) return;
    header.dataset.vdInit = '1';

    function setHeights() {
      var h = header.offsetHeight || 72;
      document.documentElement.style.setProperty('--vd-header-h', h + 'px');
    }
    setHeights();
    window.addEventListener('resize', setHeights);

    // El modo overlay (setting del schema) solo aplica si la primera seccion es el hero
    var wantsOverlay = header.dataset.overlay === 'true';
    var hero = document.querySelector('.vd-hero');
    var topbar = document.querySelector('.vd-topbar');
    var isOverlay = false;
    if (wantsOverlay && hero) {
      header.classList.add('is-overlay');
      isOverlay = true;
    }

    // En overlay el header es fixed: debe pegarse al borde inferior REAL de la
    // topbar (que scrollea con la pagina) y subir a top:0 cuando esta sale de vista.
    function positionOverlay() {
      if (!isOverlay || !topbar) return;
      var b = topbar.getBoundingClientRect().bottom;
      header.style.top = Math.max(0, b) + 'px';
    }

    function onScroll() {
      // fallback: con overflow-x hidden en body, el scroller puede ser body/html
      var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      header.classList.toggle('is-scrolled', y > 24);
      positionOverlay();
    }
    // capture:true en document: los eventos scroll NO burbujean, pero si capturan,
    // asi el listener funciona aunque el scroller sea body y no window.
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', positionOverlay);
    onScroll();
  }

  /* ----------------------------------------------------------------------
     3. Menu mobile (burger + panel lateral + scrim)
     ---------------------------------------------------------------------- */
  function initMobileMenu() {
    var burger = document.querySelector('.vd-burger');
    var panel = document.querySelector('.vd-mobile-menu');
    var scrim = document.querySelector('.vd-scrim');
    if (!burger || !panel) return;
    if (burger.dataset.vdInit) return;
    burger.dataset.vdInit = '1';

    function setOpen(open) {
      burger.classList.toggle('is-open', open);
      panel.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      document.body.classList.toggle('vd-locked', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    burger.addEventListener('click', function () { setOpen(!panel.classList.contains('is-open')); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    var close = panel.querySelector('.vd-mobile-menu__close');
    if (close) close.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ----------------------------------------------------------------------
     4. Overlay de busqueda
     ---------------------------------------------------------------------- */
  function initSearch() {
    var overlay = document.querySelector('.vd-search');
    var openBtns = document.querySelectorAll('[data-vd-search-open]');
    if (!overlay || !openBtns.length || overlay.dataset.vdInit) return;
    overlay.dataset.vdInit = '1';

    var input = overlay.querySelector('input[type="search"]');
    function setOpen(open) {
      overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('vd-locked', open);
      if (open && input) setTimeout(function () { input.focus(); }, 120);
    }
    for (var i = 0; i < openBtns.length; i++) {
      openBtns[i].addEventListener('click', function (e) { e.preventDefault(); setOpen(true); });
    }
    var close = overlay.querySelector('.vd-search__close');
    if (close) close.addEventListener('click', function () { setOpen(false); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ----------------------------------------------------------------------
     5. Slider generico (testimonios): flechas + dots + swipe tactil.
        - Flechas deshabilitadas en los extremos (estandar del workspace)
        - data-grid="true" => en desktop es grilla estatica (sin slider)
     ---------------------------------------------------------------------- */
  function initSlider(section) {
    var viewport = section.querySelector('.vd-testi__viewport');
    var track = section.querySelector('.vd-testi__track');
    if (!viewport || !track || section.dataset.vdInit) return;
    section.dataset.vdInit = '1';

    var cards = track.children;
    var prev = section.querySelector('.vd-slider-nav__btn--prev');
    var next = section.querySelector('.vd-slider-nav__btn--next');
    var dotsWrap = section.querySelector('.vd-slider-nav__dots');
    var index = 0;

    function perView() {
      var w = window.innerWidth;
      var isGridDesktop = section.classList.contains('vd-testi--grid');
      if (w > 989) return isGridDesktop ? cards.length : 3;
      if (w > 649) return 2;
      return 1;
    }
    function maxIndex() { return Math.max(0, cards.length - perView()); }

    function update() {
      var max = maxIndex();
      if (index > max) index = max;
      var offset = 0;
      if (cards.length && max > 0) {
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap) || 24;
        offset = index * (cards[0].getBoundingClientRect().width + gap);
      }
      track.style.transform = max > 0 ? 'translateX(-' + offset + 'px)' : 'none';
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === index);
          dots[i].style.display = i <= max ? '' : 'none';
        }
      }
      var nav = section.querySelector('.vd-slider-nav');
      if (nav) nav.style.display = max <= 0 ? 'none' : '';
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < cards.length; d++) {
        (function (d2) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Ir al testimonio ' + (d2 + 1));
          b.addEventListener('click', function () { index = d2; update(); });
          dotsWrap.appendChild(b);
        })(d);
      }
    }
    if (prev) prev.addEventListener('click', function () { index--; update(); });
    if (next) next.addEventListener('click', function () { index++; update(); });

    // Swipe tactil
    var startX = 0, startY = 0, swiping = false;
    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) index++; else index--;
        if (index < 0) index = 0;
        update();
      }
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  }
  function initSliders(root) {
    var sections = (root || document).querySelectorAll('.vd-testi');
    for (var i = 0; i < sections.length; i++) initSlider(sections[i]);
  }

  /* ----------------------------------------------------------------------
     6. Reveal on scroll (sutil, respeta prefers-reduced-motion)
     ---------------------------------------------------------------------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.vd-reveal:not(.is-in)');
    if (!items.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.08 });
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  /* ----------------------------------------------------------------------
     6b. Facets del catalogo: solo UX. La logica de filtrado/orden es el GET
         nativo de Shopify; aqui solo auto-enviamos el form al cambiar un
         checkbox o el orden, y cerramos dropdowns al hacer clic fuera.
     ---------------------------------------------------------------------- */
  function initFacets(root) {
    var form = (root || document).querySelector('[data-vd-facets]');
    if (!form || form.dataset.vdInit) return;
    form.dataset.vdInit = '1';

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      // los inputs numericos de precio se aplican con su boton "Aplicar"
      if (t.type === 'number') return;
      if (t.type === 'checkbox' || t.tagName === 'SELECT') form.submit();
    });

    var facets = form.querySelectorAll('details.vd-facet');
    function closeAll(except) {
      for (var i = 0; i < facets.length; i++) {
        if (facets[i] !== except) facets[i].removeAttribute('open');
      }
    }
    for (var i = 0; i < facets.length; i++) {
      (function (d) {
        d.addEventListener('toggle', function () { if (d.open) closeAll(d); });
      })(facets[i]);
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('details.vd-facet')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ----------------------------------------------------------------------
     6c. Boton flotante "volver arriba" (icono pequeno de esquina)
     ---------------------------------------------------------------------- */
  function initScrollTop() {
    var btn = document.querySelector('.vd-scrolltop');
    if (!btn || btn.dataset.vdInit) return;
    btn.dataset.vdInit = '1';

    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      btn.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
    onScroll();
  }

  /* ----------------------------------------------------------------------
     7. theme-color del navegador movil = fondo real de la paleta editable
     ---------------------------------------------------------------------- */
  function syncThemeColor() {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    var c = getComputedStyle(document.documentElement).getPropertyValue('--vd-canvas').trim();
    if (c) meta.setAttribute('content', c);
  }

  /* ---------------------------------------------------------------------- */
  function initAll(root) {
    initTopbar(root);
    syncThemeColor();
    initHeader();
    initMobileMenu();
    initSearch();
    initFacets(root);
    initScrollTop();
    initSliders(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editor de temas: reinicializa la seccion recargada
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t) {
      if (t.dataset) delete t.dataset.vdInit;
      var inner = t.querySelectorAll('[data-vd-init]');
      for (var i = 0; i < inner.length; i++) inner[i].removeAttribute('data-vd-init');
    }
    initAll(t || document);
  });
})();
